import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import 'bootswatch/dist/superhero/bootstrap.css';
import './index.css';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('app')
);
